
/**
 * Main Layout Component
 * - Provides responsive app shell with sidebar navigation
 * - Manages desktop/mobile sidebar states
 * - Includes header with search and user controls
 */

import { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { petAdminMenu } from "../navigation/menuConfig";

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // desktop expand/collapse
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false); // mobile open/close

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const toggleMobileSidebar = () => setIsMobileSidebarOpen(!isMobileSidebarOpen);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Mobile/Tablet overlay */}
      {isMobileSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40"
          onClick={toggleMobileSidebar}
        />
      )}

      {/* Sidebar */}
      <div
        className={`
          fixed lg:static top-0 left-0 h-full z-50
          transform transition-transform duration-300 ease-in-out
          ${isMobileSidebarOpen ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0
        `}
      >
        <Sidebar
          items={petAdminMenu}
          isSidebarOpen={isSidebarOpen}
          closeMobileSidebar={() => setIsMobileSidebarOpen(false)}
        />
      </div>

      {/* Main content */}
      <div className="flex flex-col flex-1">
        <Header
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          toggleMobileSidebar={toggleMobileSidebar} // pass mobile/tablet toggle
        />

        <main className="flex-1  overflow-y-auto bg-gray-50">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
